import createReactComponent from '../createReactComponent';
export default createReactComponent('currency-tenge', 'IconCurrencyTenge', [
  ['path', { d: 'M6 5h12', key: 'svg-0' }],
  ['path', { d: 'M6 9h12', key: 'svg-1' }],
  ['path', { d: 'M12 9v10', key: 'svg-2' }],
]);
